import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { AssetStorageClient, UpdateAssetStorageDirectoryPermissionsDTO, UpdateAssetStorageEntryDTO } from './../../../base/models/models.swagger.generated';
import { Injectable } from "@angular/core";
import { Observable, catchError, finalize, tap } from 'rxjs';
import { ToastService } from 'src/app/base/services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class AssetStorageService {
  constructor(private assetStorageClient: AssetStorageClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService) {    
  }

  public updateAssetStorageEntry(dto: UpdateAssetStorageEntryDTO) {
    this.spinnerService.show();
    return this.assetStorageClient.updateAssetStorageEntry(dto).pipe(
      finalize(() => this.spinnerService.hide()),
      catchError(err => {
        throw err;
      }),
    );
  }

  public updateDirectoryPermissions(dto: UpdateAssetStorageDirectoryPermissionsDTO) : Observable<void> {
    this.spinnerService.show();
    return this.assetStorageClient.updateAssetStorageDirectoryPermissions(dto).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.assets.asset-storage-permissions.messages.success-title',
          'i18n.domain.assets.asset-storage-permissions.messages.success-message');
      }),
      finalize(() => this.spinnerService.hide()),
      catchError(err => {
        this.toastService.showError('i18n.domain.assets.asset-storage-permissions.messages.fail-title',
        'i18n.domain.assets.asset-storage-permissions.messages.fail-message');
        throw err;
      }),
    );
  }

  public setAssignedCollectionsForAssets(assetIds: number[], assetCollectionIds: number[]): Observable<any> {
    this.spinnerService.show();
    return this.assetStorageClient.setAssignedCollectionsForAssets(assetIds, assetCollectionIds).pipe(
      tap(() => {
        this.toastService.showSuccess('i18n.domain.assets.asset-collections.link-asset-collection.messages.success-title',
          'i18n.domain.assets.asset-collections.link-asset-collection.messages.success-message');
      }),
      finalize(() => {
        this.spinnerService.hide();
      }),
      catchError(err => {
        this.toastService.showError('i18n.domain.assets.asset-collections.link-asset-collection.messages.fail-title',
          'i18n.domain.assets.asset-collections.link-asset-collection.messages.fail-message');
        throw err;
      }),
    );
  }
}